import { baseApi } from "../app-main/store/baseApi";

export type IncompleteEventFaqSpacesResponse = {
  spaceIds: string[];
};

/**
 * Returns space IDs whose event FAQ is incomplete for the authenticated host.
 * Backed by `GET /v2/spaces-v2/spaces/owner/faqs/event/incomplete-all`. The owner SSO id
 * is derived from the auth token, so there is no path param. When no incomplete
 * FAQs are found the server returns `{ spaceIds: [] }`.
 */
export const faqsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getIncompleteEventFaqSpaces: builder.query<
      IncompleteEventFaqSpacesResponse,
      void
    >({
      query: () => ({
        url: "/v2/spaces-v2/spaces/owner/faqs/event/incomplete-all",
      }),
    }),
  }),
});

export const { useGetIncompleteEventFaqSpacesQuery } = faqsApi;
